import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { FiDownload } from "react-icons/fi";

interface PdfDownloadButtonProps {
  label: string;
  tooltip: string;
  document: React.ReactElement;
  fileName: string;
  actionKey: string;
  fortlev?: boolean;
}

export const PdfDownloadButton = ({
  label,
  tooltip,
  document,
  fileName,
  actionKey,
  fortlev,
}: PdfDownloadButtonProps) => (
  <OverlayTrigger
    key={actionKey}
    placement="top"
    overlay={<Tooltip id={`pdf-tooltip-${actionKey}`}>{tooltip}</Tooltip>}
  >
    <span className="pdf-download-action">
      <PDFDownloadLink document={document} fileName={fileName}>
        <button
          className={
            fortlev
              ? "simulacao-button-fortlev-selected"
              : "simulacao-button-selected"
          }
        >
          {label}
          <FiDownload
            style={{
              marginRight: "5px",
              position: "relative",
              top: "-3px",
              left: "6px",
            }}
          />
        </button>
      </PDFDownloadLink>
    </span>
  </OverlayTrigger>
);
